import React from 'react';
import clsx from 'clsx';

import './index.scss';

const ClickOnlyButton = ({ label, onClick, valid = false, color='blue' }) => {
   
  const onClickFunc = (e) => {
    onClick(e);
  };

  return (
    <div className={clsx('ClickOnlyButton', { valid })}>
      <div className={clsx('button-color', 
        { blue: color === 'blue' },
        { white: color === 'white' },
      )}>
        <button
          className="button"
          type="button"
          onClick={valid ? onClickFunc : () => { console.log('no valid'); }}
        >
          {label}
        </button>
      </div>
    </div>
  );
};

export default ClickOnlyButton;